"use client";

import ComboCard from "../../components/cards/combo-card";
import {
	SKILL_COMBO_TYPES,
	type SkillComboType,
	openOnAirFoundation,
	openOnAirCoreSkill,
	openOnAirReSkill,
} from "../../utils/lms-navigation";

const SkillComboSection: React.FC = () => {
	const comboActions: Record<SkillComboType, () => void> = {
		[SKILL_COMBO_TYPES.ONAIR_FOUNDATION]: openOnAirFoundation,
		[SKILL_COMBO_TYPES.ONAIR_CORESKILL]: openOnAirCoreSkill,
		[SKILL_COMBO_TYPES.ONAIR_RESKILL]: openOnAirReSkill,
	};

	const handleComboClick = (comboType: SkillComboType) => {
		const action = comboActions[comboType];
		if (action) {
			action();
		}
	};
	const skillCombos = [
		{
			type: SKILL_COMBO_TYPES.ONAIR_FOUNDATION,
			title: "OnAir Foundation",
			description: "Nền tảng kỹ năng AI dành cho kỷ nguyên số",
			logoSrc: "/assets/images/onair-ai-foundation-logo.svg",
			logoAlt: "OnAir AI Foundation",
			backgroundSrc: "/assets/images/onair-ai-foundation-background.png",
			meshBackground: "/assets/images/onair-ai-foundation-logo-mesh.png",
		},
		{
			type: SKILL_COMBO_TYPES.ONAIR_CORESKILL,
			title: "OnAir CoreSkill",
			description: "Xây dựng kỹ năng cốt lõi để bứt phá trong công việc",
			logoSrc: "/assets/images/onair-core-skill-logo.svg",
			logoAlt: "OnAir Core Skill",
			backgroundSrc: "/assets/images/onair-core-skill-background.png",
			meshBackground: "/assets/images/onair-core-skill-mesh.png",
		},
		{
			type: SKILL_COMBO_TYPES.ONAIR_RESKILL,
			title: "OnAir Re-Skill",
			description: "Làm mới sự nghiệp để sẵn sàng chuyển hướng",
			logoSrc: "/assets/images/onair-reskill-logo.svg",
			logoAlt: "OnAir Re-Skill",
			backgroundSrc: "/assets/images/onair-reskill-background.png",
			meshBackground: "/assets/images/onair-reskill-mesh.png",
		},
	];

	return (
		<section className="mb-12">
			<h2 className="text-2xl font-semibold text-gray-800 mb-6">
				Combo trọn gói kỹ năng
			</h2>
			<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
				{skillCombos.map((combo) => (
					<div key={combo.type} onClick={() => handleComboClick(combo.type)}>
						<ComboCard
							title={combo.title}
							description={combo.description}
							logoSrc={combo.logoSrc}
							logoAlt={combo.logoAlt}
							backgroundSrc={combo.backgroundSrc}
							meshBackground={combo.meshBackground}
						/>
					</div>
				))}
			</div>
		</section>
	);
};

export default SkillComboSection;
